"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDateTimePicker = void 0;
const React = __importStar(require("react"));
const kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
const utils_1 = require("../../utils");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const __1 = require("../");
const ll_1 = require("../../languages/ll");
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer = styled_components_1.default.div `
   width: 20px;
   display: flex;
   align-items: center;
`;
class ZDateTimePickerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.componentRef = React.createRef();
        this.boundClearHandler = this.clearHandler.bind(this);
        this.state = { value: props.value || props.defaultValue, hovered: false };
    }
    componentDidMount() {
        const DateTimePicker = this.componentRef && this.componentRef.current;
        const dateInput = DateTimePicker &&
            DateTimePicker.dateInput &&
            DateTimePicker.dateInput.element;
        if (dateInput) {
            dateInput.addEventListener("click", () => {
                if (DateTimePicker) {
                    DateTimePicker.setState({
                        show: !DateTimePicker.state.show
                    });
                }
            });
        }
    }
    clearHandler(event) {
        event.preventDefault();
        const DateTimePicker = this.componentRef && this.componentRef.current;
        if (DateTimePicker) {
            DateTimePicker.setState({ value: null });
        }
        this.setState({ hovered: false, value: null });
        this.props.onChange &&
            this.props.onChange(event);
    }
    setValue(value) {
        const dateTimePicker = this.componentRef && this.componentRef.current;
        if (dateTimePicker) {
            dateTimePicker.setState({ value });
        }
        this.setState({ hovered: false, value });
        this.props.onChange &&
            this.props.onChange({
                target: { value }
            }, value, false);
    }
    render() {
        const { label } = this.props, { languageId } = this.context;
        kendo_react_intl_1.loadMessages({
            datetimepicker: {
                date: ll_1.ll({
                    key: "Date",
                    languageId
                }),
                time: ll_1.ll({
                    key: "Time",
                    languageId
                }),
                cancel: ll_1.ll({
                    key: "Cancel",
                    languageId
                }),
                set: ll_1.ll({
                    key: "Set",
                    languageId
                }),
                selectNow: ll_1.ll({
                    key: "SelectNow",
                    languageId
                }),
                toggleDateTimeSelector: ll_1.ll({
                    key: "ToggleDateTimeSelector",
                    languageId
                })
            },
            calendar: {
                today: ll_1.ll({
                    key: "Today",
                    languageId
                })
            }
        }, languageId);
        return (React.createElement(__1.RequiredDot, { required: this.props.required, raised: !!this.props.label, raisedTransform: "right-2 down-18", loweredTransform: "down-16" },
            React.createElement("span", { id: this.props.id, className: [
                    this.props.className,
                    "z-component z-datetimepicker",
                    this.props.disabled ? "disabled" : ""
                ].join(" ") },
                React.createElement("span", { className: "date-picker-label" }, ll_1.ll({ key: label || "", languageId })),
                React.createElement("div", { onMouseEnter: e => this.setState({ hovered: true }), onMouseLeave: e => this.setState({ hovered: false }), className: this.state.hovered ? "hovered" : "" },
                    React.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId },
                        React.createElement(kendo_react_dateinputs_1.DateTimePicker, Object.assign({}, this.props, { formatPlaceholder: {
                                day: "--",
                                month: "--",
                                year: "----",
                                hour: "--",
                                minute: "--",
                                second: "--"
                            }, ref: this.componentRef, onChange: e => {
                                this.setState({
                                    value: e.target.value,
                                    hovered: false
                                });
                                this.props.onChange && this.props.onChange(e);
                            } }))),
                    React.createElement(utils_1.FrameContextConsumer, null, (frameContext) => react_dom_1.default.createPortal(this.componentRef.current &&
                        this.state.value &&
                        this.state.hovered &&
                        !this.props.disabled ? (React.createElement(IconContainer, null,
                        React.createElement("div", { className: "k-icon k-clear-value k-i-close z-clear-button", role: "button", tabIndex: -1, title: ll_1.ll("Clear"), onClick: this.boundClearHandler }))) : (React.createElement(IconContainer, null)), (this.componentRef &&
                        this.componentRef.current &&
                        this.componentRef.current.dateInput &&
                        this.componentRef.current.dateInput.element &&
                        this.componentRef.current.dateInput.element
                            .parentElement) ||
                        frameContext.document.body))))));
    }
}
ZDateTimePickerComponent.contextType = ll_1.llContext;
exports.ZDateTimePicker = styled_components_1.default(ZDateTimePickerComponent) `
   & .k-widget {
      box-sizing: content-box;
      &.k-datetimepicker {
         position: relative;
         left: -9px;
         & .k-dateinput {
            position: relative;
            left: 2px;
         }
      }
   }
   & .date-picker-label {
      font-family: ${props => props.theme["font-family"]};
      font-size: 12px;
      top: 11px;
      left: 4px;
      position: relative;
      color: ${props => props.valid === false
    ? props.theme["alert-color"]
    : "rgba(0, 0, 0, 0.6)"};
      display: block;
   }
   &.disabled.disabled.disabled .date-picker-label {
      color: ${props => props.theme["disabled-color"]};
   }
   & .k-dateinput,
   & .k-link-date,
   & .k-dateinput .k-dateinput-wrap .k-input {
      font-family: ${props => props.theme["font-family"]};
      margin: 0px 0px 0px 0px;
      color: ${props => !props.value && !props.defaultValue
    ? "transparent !important"
    : props.valid === false
        ? props.theme["alert-color"] + " !important"
        : "rgba(0, 0, 0, 0.87)"};

      &:focus {
         color: rgba(0, 0, 0, 0.87) !important;
      }
      &:hover:not(:disabled),
      .hovered &:not(:disabled) {
         border-bottom-color: rgba(0, 0, 0, 0.87);
         background: ${props => props.valid === false
    ? props.theme["validation-background-color"]
    : props.theme["input-background-hover-color"]};
      }
   }
   padding: 10px;
   width: 200px;
   display: inline-block;
   & .z-clear-button {
      position: relative;
      left: -5px;
      align-self: center;
      opacity: 0.5;
      cursor: pointer;
   }
`;
//# sourceMappingURL=ZDateTimePicker.js.map